<div class="field row" *ngIf="value != null">
    <label class="field-label" for="cash-down" translate="cashDownAmountLabel"></label>
    <span class="field-data qa-cash-down-value" id="cash-down">{{value | localeCurrency}}</span>
</div>
